import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbsService {

    level = 0;

    stackFolder: Subject<any> = new Subject();
    moveUpFolder: Subject<any> = new Subject();

    openFolder: Subject<any> = new Subject();

}
